import { render, staticRenderFns } from "./RadioOther.vue?vue&type=template&id=2d1ea013"
import script from "./RadioOther.vue?vue&type=script&lang=js"
export * from "./RadioOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports